export const raiseBidPopupStyles = () => ({

  '& .raise-bid-popup-content': {
    width: '355px',
    zIndex: 1,
    position: 'absolute',
    color: 'black',
    background: '#fff',
    padding: '16px 14px 16px 16px',
    border: 'solid 1px #dddddd',
    left: '22px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'default',
    fontFamily: 'Segoe UI,Tahoma,Geneva,Verdana,sans-serif',
    boxShadow: '0 6.4px 14.4px 0 rgba(0,0,0,.132), 0 1.2px 3.6px 0 rgba(0,0,0,.108)',

    '& .close-button.closeimage': {
      float: 'right',
      position: 'relative',
      cursor: 'pointer',
      color: '#333333',
      verticalAlign: 'middle',
    },

    '& strong.title': {
      marginRight: '24px',
      fontSize: '20px',
      lineHeight: '1.5',
      display: 'block',
    },

    '& .subcontent': {
      marginRight: '24px',
      marginTop: '24px',
      lineHeight: 'normal',
    },

    '& label.choices': {
      marginRight: '24px',
      marginTop: '11px',
      marginBottom: '11px',
      fontWeight: 'normal',

      '& span.bid-suggestion': {
        position: 'relative',
        top: '-2px',
      },
    },

    '& .btn.btn-default.cancel': {
      marginLeft: '8px',
    },
  },
});
